export default __webpack_public_path__ + "static/wotfard-regular-webfont-aa3e9787a0a0b35c49abe12f615b476c.woff2";